// extracted by mini-css-extract-plugin
module.exports = {"root":"Icon_root__mqVvi","default":"Icon_default__rsPNU","small":"Icon_small__nD__x","light":"Icon_light__xPExP","dark":"Icon_dark__bhUcq"};